import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
export function AboutSection() {
  const stats = [{
    label: 'Founded',
    value: '2020'
  }, {
    label: 'People Helped',
    value: '5000+'
  }, {
    label: 'Partners',
    value: '50+'
  }, {
    label: 'Events',
    value: '100+'
  }];
  const values = ['Transparency in Operations', 'Integrity & Ethics', 'Compassion for Players', 'Collaboration with Regulators'];
  return <section id="about" className="py-20 bg-gray-50" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-14">
            <SectionHeading title="About Us" subtitle="Dedicated to fostering a safe and regulated gambling ecosystem." centered={false} data-id="element-15" />

            <p className="text-gray-600 text-lg mb-6 leading-relaxed" data-id="element-16">
              Fair Gaming Space NGO was established to address the critical need
              for independent oversight and player protection in the rapidly
              evolving gambling industry. We act as a bridge between operators,
              regulators, and the public.
            </p>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-17">
              Our team consists of legal experts, psychologists, and industry
              veterans working together to ensure that gambling remains a form
              of entertainment, not a source of harm.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-18">
              {values.map((value, index) => <div key={index} className="flex items-center space-x-3" data-id="element-19">
                  <CheckCircle2 className="text-[#d4a74a] flex-shrink-0" size={20} data-id="element-20" />
                  <span className="text-gray-800 font-medium" data-id="element-21">{value}</span>
                </div>)}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-gray-200 pt-8" data-id="element-22">
              {stats.map((stat, index) => <div key={index} className="text-center sm:text-left" data-id="element-23">
                  <div className="text-2xl md:text-3xl font-bold text-[#0f5f5f] font-serif mb-1" data-id="element-24">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-500 uppercase tracking-wide" data-id="element-25">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative h-[500px] rounded-lg overflow-hidden shadow-2xl" data-id="element-26">
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80" alt="Team meeting" className="absolute inset-0 w-full h-full object-cover" data-id="element-27" />
            <div className="absolute inset-0 bg-[#0f5f5f]/20 mix-blend-multiply" data-id="element-28" />
          </motion.div>
        </div>
      </div>
    </section>;
}